module.exports = __webpack_public_path__ + "static/media/pla_exc_zon.b52b23d7.png";